import React from 'react';
import { useLocation, useParams, Link } from 'react-router-dom';
import {
  Container,
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Paper,
} from '@mui/material';
import { Save, Cancel } from '@mui/icons-material';
import AddEditQuotes from './../../AddEditQuotes/AddEditQuotes';

const QuotesAddEditPage = () => {
  const location = useLocation();
  const { id } = useParams();
  const isEdit = location.pathname.includes('edit');
  const quotesRef = React.useRef();

  const handleSave = (e) => {
    e.preventDefault();
    quotesRef.current?.submit();
  };

  return (
    <Container sx={{ paddingBottom: 4 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {isEdit ? "Edit Quote" : "Create New Quote"}
          </Typography>
          <Button
            color="error"
            component={Link}
            to="/quotes"
            startIcon={<Cancel />}
            variant="contained"
            sx={{ marginRight: 2 }}
          >
            Cancel
          </Button>
          <Button
            color="success"
            onClick={handleSave}
            startIcon={<Save />}
            variant="contained"
          >
            {isEdit ? "Update" : "Create"}
          </Button>
        </Toolbar>
      </AppBar>
      <Box gap={4}>
        <Paper sx={{ padding: 2 }}>
          <AddEditQuotes
            ref={quotesRef}
            isEdit={isEdit}
            selectedId={id}
          />
        </Paper>
      </Box>
    </Container>
  );
};

export default QuotesAddEditPage;
